<template>
  <div class="wrapBox">
    <div
      class="allBox"
      v-for="(item, index) in allList"
      :class="item.orderStatus == 4 && item.payState == 0 ? 'isactive' : ''"
      v-bind:key="index"
      @click="goDetail(item.roomId)"
    >
      <div class="t1">线上认筹：{{ item.houseInfo }}</div>
      <!-- <div>{{item.projectName}}</div> -->
      <div v-if="item.orderTime">
        创建时间:{{ item.orderTime | formatDate }}
      </div>
      <div class="status" v-if="item.statusName">{{ item.statusName }}</div>
      <div class="detail" v-if="item.treatyUrl">查看协议</div>
      <div
        class="btn lastPay"
        v-if="item.orderStatus == 4 && item.payState == 0"
      >
        房源已售出
      </div>
      <div
        class="btn twoPay"
        v-else-if="item.orderStatus == 4 && item.payState == 1"
      >
        支付成功
      </div>
      <div
        class="btn firstPay"
        v-else-if="item.orderStatus == 2 && item.payState == 0"
      >
        订单已提交
      </div>
      <div
        class="btn firstPay"
        v-else-if="item.orderStatus == 1 && item.payState == 0"
      >
        初始状态
      </div>
      <div class="btn hasPay" v-else-if="item.orderStatus == 0">
        申请单取消
      </div>
    </div>
    <div class="common-nodata-item" v-if="noData">暂无数据</div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox } from "mint-ui";
import request from "@/utils/request";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import "./components/all.css";
export default {
  components: {},
  data() {
    return {
      openid: Cookies.get("openid"),
      projectId: this.$route.query.pid ? parseInt(this.$route.query.pid) : 2343,
      allList: [],
      noData: false
    };
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      //	      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m;
    }
  },
  methods: {
    getAllData() {
      let that = this;
      request
        .get(that.global.API_URL, {
          action: "/house/HouseOnlineAction/getOrderList",
          requestParam: {
            projectId: that.projectId,
            all: 0,
            offset: 0,
            size: 500
          }
        })
        .then(function(data) {
          console.log(data.obj);
          if (data.obj.list.length > 0) {
            that.allList = data.obj.list;
          }
        });
    },
    goDetail(roomid) {
      let that = this;
      console.log(roomid);
      that.$router.push(
        "payHouse?pid=" + that.projectId + "&houseCode=" + roomid
      );
    }
  },
  mounted() {
    let that = this;
    //设置分享
    that.global.SHARE_TITLE = `线上售楼中心，看房咨询一步到位，最新购房优惠抢先看！`;
    that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
    that.global.SHARE_IMG_URL =
       "http://assets.rurushishi.com/yq-rs-make/huafasubscription/hfrgShare.jpg";
    let shareLink = `${location.protocol}//${location.host}/h5/huafasubscription/housePage?pid=${that.projectId}`
    that.global.SHARE_LINK = shareLink;
    wxsdk.init();
    that.getAllData();
    comreq.getUserInfo().then(function(userInfo) {
      console.log(userInfo);
    });
  }
};
</script>
<style lang="stylus" scoped>
.wrapBox {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.allBox{
  width: 6.86rem
  height: 1.73rem
  background: url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/orderBg.png') no-repeat center center;
  background-size: 6.86rem 1.73rem
  margin: 12px auto
  display: flex
  flex-direction: column
  position: relative
  justify-content: center
}
.isactive{
  background: url('http://assets.rurushishi.com/yq-rs-make/huafasubscription/orderBg3.png') no-repeat center center;
  background-size: 6.86rem 1.73rem
}
.allBox > div {
  line-height: .52rem
  font-size: .24rem
  color: #333333
  padding-left: .2rem
}

.allBox .t1 {
  font-size .28rem
  font-weight bold
  color #D82831
  width 4rem
  text-overflow -o-ellipsis-lastline
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical
}
.allBox .btn {
  width: 1.8rem
  height: .56rem
  line-height: .56rem
  text-align: center
  // background #E6002D
  color: #fff
  font-size: .24rem
  position: absolute
  right: 0.3rem
  top: 0.6rem
  border-radius: 4px
  padding: 0
}
.allBox .hasPay{
  color #d82831
  font-weight bold
}
.allBox .firstPay{
  color #e6002d
  font-weight bold
}
.allBox .twoPay{
  color #00a120
  font-weight bold
}
.allBox .lastPay{
  color #949494
  font-weight bold
}
</style>
